import ChartDatasets from "./datasets/dataset_helper"
import ChartOptions from "./options/options"
export default {
    name: "DuplicatesChartComponent",
    datasets: [],
    labels: "months",
    loading: true,
    style:"height: 150px",
    options: ChartOptions.getDuplicatesChartOptions(),
    config: {
        datasets: {
            today: {
                backgroundColor: "#ffffff73",
                borderColor: "#f5c29f",
            },
            yesterday: {
                backgroundColor: "#ffffff73",
                borderColor: "#f5c29f",
            }
        }

    }
}